/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServiceTargetAreasService {
  /** @summary Get All */
  getAllServiceTargetAreasGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetAllServiceTargetAreasGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllServiceTargetAreasGetSchema,
        options: {
          parameters: GetAllServiceTargetAreasGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetError>>
    ): Promise<RequestFnResponse<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllServiceTargetAreasGetParameters> | void
    ): ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllServiceTargetAreasGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllServiceTargetAreasGetData,
          GetAllServiceTargetAreasGetError,
          TData,
          ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllServiceTargetAreasGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllServiceTargetAreasGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllServiceTargetAreasGetData,
          GetAllServiceTargetAreasGetError,
          TData,
          ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllServiceTargetAreasGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllServiceTargetAreasGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllServiceTargetAreasGetParameters,
      TQueryFnData = GetAllServiceTargetAreasGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllServiceTargetAreasGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllServiceTargetAreasGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllServiceTargetAreasGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllServiceTargetAreasGetParameters,
      TQueryFnData = GetAllServiceTargetAreasGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllServiceTargetAreasGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllServiceTargetAreasGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllServiceTargetAreasGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllServiceTargetAreasGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllServiceTargetAreasGetTotal = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllServiceTargetAreasGetResults = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServiceTargetAreasGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllServiceTargetAreasGetCombinedResults = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServiceTargetAreasGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllServiceTargetAreasGetSchema,
          GetAllServiceTargetAreasGetParameters,
          GetAllServiceTargetAreasGetData,
          GetAllServiceTargetAreasGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllServiceTargetAreasGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllServiceTargetAreasGetData,
          GetAllServiceTargetAreasGetError,
          TData,
          ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllServiceTargetAreasGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllServiceTargetAreasGetParameters,
      TData = GetAllServiceTargetAreasGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllServiceTargetAreasGetData,
          GetAllServiceTargetAreasGetError,
          OperationInfiniteData<TData, GetAllServiceTargetAreasGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllServiceTargetAreasGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllServiceTargetAreasGetParameters>,
      OperationError<GetAllServiceTargetAreasGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllServiceTargetAreasGetData = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServiceTargetAreasGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllServiceTargetAreasGetCombinedData = qraft.serviceTargetAreasService.getAllServiceTargetAreasGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServiceTargetAreasGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllServiceTargetAreasGetSchema,
          GetAllServiceTargetAreasGetParameters,
          GetAllServiceTargetAreasGetData,
          GetAllServiceTargetAreasGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllServiceTargetAreasGetSchema,
        GetAllServiceTargetAreasGetData,
        GetAllServiceTargetAreasGetParameters,
        GetAllServiceTargetAreasGetError
      > | void
    ): Promise<GetAllServiceTargetAreasGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllServiceTargetAreasGetSchema,
        GetAllServiceTargetAreasGetData,
        GetAllServiceTargetAreasGetParameters,
        GetAllServiceTargetAreasGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllServiceTargetAreasGetSchema,
        GetAllServiceTargetAreasGetData,
        GetAllServiceTargetAreasGetParameters,
        GetAllServiceTargetAreasGetError
      > | void
    ): Promise<GetAllServiceTargetAreasGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllServiceTargetAreasGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllServiceTargetAreasGetSchema,
        GetAllServiceTargetAreasGetData,
        GetAllServiceTargetAreasGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceTargetAreasGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllServiceTargetAreasGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllServiceTargetAreasGetSchema,
        GetAllServiceTargetAreasGetData,
        GetAllServiceTargetAreasGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceTargetAreasGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllServiceTargetAreasGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllServiceTargetAreasGetSchema,
        GetAllServiceTargetAreasGetData,
        GetAllServiceTargetAreasGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceTargetAreasGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void)
    ): GetAllServiceTargetAreasGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void)
    ): OperationInfiniteData<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllServiceTargetAreasGetSchema,
              GetAllServiceTargetAreasGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllServiceTargetAreasGetSchema,
              GetAllServiceTargetAreasGetParameters
            >,
            data: GetAllServiceTargetAreasGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | void)
    ): QueryState<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllServiceTargetAreasGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetParameters>,
          GetAllServiceTargetAreasGetError
        >
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>,
      updater: Updater<
        NoInfer<GetAllServiceTargetAreasGetData> | undefined,
        NoInfer<DeepReadonly<GetAllServiceTargetAreasGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllServiceTargetAreasGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllServiceTargetAreasGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllServiceTargetAreasGetSchema, GetAllServiceTargetAreasGetParameters>,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllServiceTargetAreasGetData, GetAllServiceTargetAreasGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >,
      updater: Updater<
        NoInfer<GetAllServiceTargetAreasGetData> | undefined,
        NoInfer<GetAllServiceTargetAreasGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllServiceTargetAreasGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllServiceTargetAreasGetSchema,
        GetAllServiceTargetAreasGetData,
        TInfinite,
        GetAllServiceTargetAreasGetParameters,
        GetAllServiceTargetAreasGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTargetAreasGetSchema,
            GetAllServiceTargetAreasGetData,
            TInfinite,
            GetAllServiceTargetAreasGetParameters,
            GetAllServiceTargetAreasGetError
          >
    ): number;
    schema: GetAllServiceTargetAreasGetSchema;
    types: {
      parameters: GetAllServiceTargetAreasGetParameters;
      data: GetAllServiceTargetAreasGetData;
      error: GetAllServiceTargetAreasGetError;
    };
  };
  /** @summary Create */
  createServiceTargetAreasPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateServiceTargetAreasPostBody,
        CreateServiceTargetAreasPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateServiceTargetAreasPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateServiceTargetAreasPostBody,
          CreateServiceTargetAreasPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateServiceTargetAreasPostData, CreateServiceTargetAreasPostError>>
    ): Promise<RequestFnResponse<CreateServiceTargetAreasPostData, CreateServiceTargetAreasPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateServiceTargetAreasPostParameters> | void
    ): ServiceOperationMutationKey<CreateServiceTargetAreasPostSchema, CreateServiceTargetAreasPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.createServiceTargetAreasPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.createServiceTargetAreasPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateServiceTargetAreasPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateServiceTargetAreasPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceTargetAreasPostSchema,
        CreateServiceTargetAreasPostData,
        CreateServiceTargetAreasPostParameters,
        TVariables,
        OperationError<CreateServiceTargetAreasPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServiceTargetAreasPostData,
      OperationError<CreateServiceTargetAreasPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.createServiceTargetAreasPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.createServiceTargetAreasPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateServiceTargetAreasPostBody, CreateServiceTargetAreasPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceTargetAreasPostSchema,
        CreateServiceTargetAreasPostData,
        CreateServiceTargetAreasPostParameters,
        TVariables,
        OperationError<CreateServiceTargetAreasPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServiceTargetAreasPostData,
      OperationError<CreateServiceTargetAreasPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createServiceTargetAreasPostTotal = qraft.serviceTargetAreasService.createServiceTargetAreasPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createServiceTargetAreasPostTotal = qraft.serviceTargetAreasService.createServiceTargetAreasPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceTargetAreasPostBody,
            CreateServiceTargetAreasPostData,
            CreateServiceTargetAreasPostParameters,
            OperationError<CreateServiceTargetAreasPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceTargetAreasPostSchema,
            CreateServiceTargetAreasPostBody,
            CreateServiceTargetAreasPostData,
            CreateServiceTargetAreasPostParameters,
            OperationError<CreateServiceTargetAreasPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createServiceTargetAreasPostPendingMutationVariables = qraft.serviceTargetAreasService.createServiceTargetAreasPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createServiceTargetAreasPostMutationData = qraft.serviceTargetAreasService.createServiceTargetAreasPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateServiceTargetAreasPostData,
        OperationError<CreateServiceTargetAreasPostError>,
        MutationVariables<CreateServiceTargetAreasPostBody, CreateServiceTargetAreasPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateServiceTargetAreasPostBody,
            CreateServiceTargetAreasPostData,
            CreateServiceTargetAreasPostParameters,
            OperationError<CreateServiceTargetAreasPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceTargetAreasPostSchema,
            CreateServiceTargetAreasPostBody,
            CreateServiceTargetAreasPostData,
            CreateServiceTargetAreasPostParameters,
            OperationError<CreateServiceTargetAreasPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateServiceTargetAreasPostData,
          OperationError<CreateServiceTargetAreasPostError>,
          MutationVariables<CreateServiceTargetAreasPostBody, CreateServiceTargetAreasPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceTargetAreasPostBody,
            CreateServiceTargetAreasPostData,
            CreateServiceTargetAreasPostParameters,
            OperationError<CreateServiceTargetAreasPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceTargetAreasPostSchema,
            CreateServiceTargetAreasPostBody,
            CreateServiceTargetAreasPostData,
            CreateServiceTargetAreasPostParameters,
            OperationError<CreateServiceTargetAreasPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceTargetAreasService.createServiceTargetAreasPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceTargetAreasService.createServiceTargetAreasPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateServiceTargetAreasPostBody,
              CreateServiceTargetAreasPostData,
              CreateServiceTargetAreasPostParameters,
              OperationError<CreateServiceTargetAreasPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceTargetAreasPostSchema,
              CreateServiceTargetAreasPostBody,
              CreateServiceTargetAreasPostData,
              CreateServiceTargetAreasPostParameters,
              OperationError<CreateServiceTargetAreasPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateServiceTargetAreasPostData,
            CreateServiceTargetAreasPostError,
            MutationVariables<CreateServiceTargetAreasPostBody, CreateServiceTargetAreasPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateServiceTargetAreasPostBody,
              CreateServiceTargetAreasPostData,
              CreateServiceTargetAreasPostParameters,
              OperationError<CreateServiceTargetAreasPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceTargetAreasPostSchema,
              CreateServiceTargetAreasPostBody,
              CreateServiceTargetAreasPostData,
              CreateServiceTargetAreasPostParameters,
              OperationError<CreateServiceTargetAreasPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateServiceTargetAreasPostData,
          CreateServiceTargetAreasPostError,
          MutationVariables<CreateServiceTargetAreasPostBody, CreateServiceTargetAreasPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateServiceTargetAreasPostSchema;
    types: {
      parameters: CreateServiceTargetAreasPostParameters;
      data: CreateServiceTargetAreasPostData;
      error: CreateServiceTargetAreasPostError;
      body: CreateServiceTargetAreasPostBody;
    };
  };
  /** @summary Update */
  updateServiceTargetAreasServiceTargetAreaIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
        UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
          UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
          UpdateServiceTargetAreasServiceTargetAreaIdPatchError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
        UpdateServiceTargetAreasServiceTargetAreaIdPatchError
      >
    >;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters> | void
    ): ServiceOperationMutationKey<
      UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
      UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.useMutation({
     *     path: {
     *         service_target_area_id: serviceTargetAreaId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_target_area_id: serviceTargetAreaId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateServiceTargetAreasServiceTargetAreaIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
        UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
        UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
        TVariables,
        OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
      OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.useMutation({
     *     path: {
     *         service_target_area_id: serviceTargetAreaId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_target_area_id: serviceTargetAreaId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
        UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
        UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
        UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
        TVariables,
        OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
      OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateServiceTargetAreasServiceTargetAreaIdPatchTotal = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateServiceTargetAreasServiceTargetAreaIdPatchTotal = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_target_area_id: serviceTargetAreaId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
            OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
            OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateServiceTargetAreasServiceTargetAreaIdPatchPendingMutationVariables = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateServiceTargetAreasServiceTargetAreaIdPatchMutationData = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_target_area_id: serviceTargetAreaId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
        OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
        MutationVariables<
          UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
          UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
            OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
            OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
          OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
          MutationVariables<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
            OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
            OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_target_area_id: serviceTargetAreaId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceTargetAreasService.updateServiceTargetAreasServiceTargetAreaIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
              OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
              OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchError,
            MutationVariables<
              UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
              OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
              UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters,
              OperationError<UpdateServiceTargetAreasServiceTargetAreaIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateServiceTargetAreasServiceTargetAreaIdPatchData,
          UpdateServiceTargetAreasServiceTargetAreaIdPatchError,
          MutationVariables<
            UpdateServiceTargetAreasServiceTargetAreaIdPatchBody,
            UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema;
    types: {
      parameters: UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters;
      data: UpdateServiceTargetAreasServiceTargetAreaIdPatchData;
      error: UpdateServiceTargetAreasServiceTargetAreaIdPatchError;
      body: UpdateServiceTargetAreasServiceTargetAreaIdPatchBody;
    };
  };
  /** @summary Delete */
  deleteServiceTargetAreasServiceTargetAreaIdDelete: {
    /** @summary Delete */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteError
      >
    >;
    /** @summary Delete */
    getMutationKey(
      parameters: DeepReadonly<DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
      DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.useMutation({
     *     path: {
     *         service_target_area_id: serviceTargetAreaId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_target_area_id: serviceTargetAreaId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
        TVariables,
        OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
      OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.useMutation({
     *     path: {
     *         service_target_area_id: serviceTargetAreaId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_target_area_id: serviceTargetAreaId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
        TVariables,
        OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
      OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteServiceTargetAreasServiceTargetAreaIdDeleteTotal = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteServiceTargetAreasServiceTargetAreaIdDeleteTotal = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_target_area_id: serviceTargetAreaId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
            OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
            OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteServiceTargetAreasServiceTargetAreaIdDeletePendingMutationVariables = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteServiceTargetAreasServiceTargetAreaIdDeleteMutationData = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_target_area_id: serviceTargetAreaId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
        OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
        MutationVariables<
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
            OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
            OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
          OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
          MutationVariables<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Delete */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
            OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
            OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_target_area_id: serviceTargetAreaId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceTargetAreasService.deleteServiceTargetAreasServiceTargetAreaIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
              OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
              OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteError,
            MutationVariables<
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
              OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
              DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters,
              OperationError<DeleteServiceTargetAreasServiceTargetAreaIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteData,
          DeleteServiceTargetAreasServiceTargetAreaIdDeleteError,
          MutationVariables<
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody,
            DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema;
    types: {
      parameters: DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters;
      data: DeleteServiceTargetAreasServiceTargetAreaIdDeleteData;
      error: DeleteServiceTargetAreasServiceTargetAreaIdDeleteError;
      body: DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody;
    };
  };
}
/** @summary Get All */
export const getAllServiceTargetAreasGet = {
  schema: {
    method: 'get',
    url: '/service_target_areas',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllServiceTargetAreasGetSchema;
  [QraftServiceOperationsToken]: ServiceTargetAreasService['getAllServiceTargetAreasGet'];
};
/** @summary Create */
export const createServiceTargetAreasPost = {
  schema: {
    method: 'post',
    url: '/service_target_areas',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateServiceTargetAreasPostSchema;
  [QraftServiceOperationsToken]: ServiceTargetAreasService['createServiceTargetAreasPost'];
};
/** @summary Update */
export const updateServiceTargetAreasServiceTargetAreaIdPatch = {
  schema: {
    method: 'patch',
    url: '/service_target_areas/{service_target_area_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema;
  [QraftServiceOperationsToken]: ServiceTargetAreasService['updateServiceTargetAreasServiceTargetAreaIdPatch'];
};
/** @summary Delete */
export const deleteServiceTargetAreasServiceTargetAreaIdDelete = {
  schema: {
    method: 'delete',
    url: '/service_target_areas/{service_target_area_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema;
  [QraftServiceOperationsToken]: ServiceTargetAreasService['deleteServiceTargetAreasServiceTargetAreaIdDelete'];
};
export const serviceTargetAreasService = {
  getAllServiceTargetAreasGet,
  createServiceTargetAreasPost,
  updateServiceTargetAreasServiceTargetAreaIdPatch,
  deleteServiceTargetAreasServiceTargetAreaIdDelete,
} as const;
type GetAllServiceTargetAreasGetSchema = {
  method: 'get';
  url: '/service_target_areas';
  security: ['HTTPBearer'];
};
type GetAllServiceTargetAreasGetParameters = undefined;
type GetAllServiceTargetAreasGetData =
  paths['/service_target_areas']['get']['responses']['200']['content']['application/json'];
type GetAllServiceTargetAreasGetError = unknown;
type CreateServiceTargetAreasPostSchema = {
  method: 'post';
  url: '/service_target_areas';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateServiceTargetAreasPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateServiceTargetAreasPostData =
  paths['/service_target_areas']['post']['responses']['201']['content']['application/json'];
type CreateServiceTargetAreasPostError =
  paths['/service_target_areas']['post']['responses']['422']['content']['application/json'];
type CreateServiceTargetAreasPostBody =
  paths['/service_target_areas']['post']['requestBody']['content']['application/json'];
type UpdateServiceTargetAreasServiceTargetAreaIdPatchSchema = {
  method: 'patch';
  url: '/service_target_areas/{service_target_area_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateServiceTargetAreasServiceTargetAreaIdPatchParameters =
  paths['/service_target_areas/{service_target_area_id}']['patch']['parameters'];
type UpdateServiceTargetAreasServiceTargetAreaIdPatchData =
  paths['/service_target_areas/{service_target_area_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateServiceTargetAreasServiceTargetAreaIdPatchError =
  paths['/service_target_areas/{service_target_area_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateServiceTargetAreasServiceTargetAreaIdPatchBody =
  paths['/service_target_areas/{service_target_area_id}']['patch']['requestBody']['content']['application/json'];
type DeleteServiceTargetAreasServiceTargetAreaIdDeleteSchema = {
  method: 'delete';
  url: '/service_target_areas/{service_target_area_id}';
  security: ['HTTPBearer'];
};
type DeleteServiceTargetAreasServiceTargetAreaIdDeleteParameters =
  paths['/service_target_areas/{service_target_area_id}']['delete']['parameters'];
type DeleteServiceTargetAreasServiceTargetAreaIdDeleteData = null;
type DeleteServiceTargetAreasServiceTargetAreaIdDeleteError =
  paths['/service_target_areas/{service_target_area_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteServiceTargetAreasServiceTargetAreaIdDeleteBody = undefined;
